<!--
    BUTTON IN THE HOME ACTION COMPONENT
    © AREA 19, OCG WEB APP.
    DEVELOPED IN MONTREAL, QC, CANADA.
    APRIL 2025.
  -->
<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <v-btn class="simple-panel px-4 py-2" style="height: 40px;">
    <h5 class="flex items-center justify-between gap-2">
      {{ props.label }}
      <i :class="props.icon" class="default-icon" />
    </h5>
  </v-btn>
</template>
